import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b6dd58b8")

_pushScopeId("data-v-b6dd58b8")
const _hoisted_1 = { class: "row container" }
const _hoisted_2 = { class: "nav-tree" }
const _hoisted_3 = { class: "list" }
const _hoisted_4 = { class: "col h-full align-center" }
const _hoisted_5 = { class: "buttons w-full text-end flex" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "flex-1" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("创建模板 ")
const _hoisted_8 = { class: "flex" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("查看")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "flex-1" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_category_tree = _resolveComponent("category-tree")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_template_form = _resolveComponent("template-form")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_category_tree, {
          currentCategoryId: _ctx.currentCategoryId,
          categoryType: "TEMPLATE",
          onNodeClick: _ctx.filterCategory
        }, null, 8, ["currentCategoryId", "onNodeClick"])
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_el_button, {
              type: "primary",
              icon: "el-icon-circle-plus-outline",
              onClick: _ctx.addTemplate
            }, {
              default: _withId(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createVNode(_component_el_table, {
            data: _ctx.tableData.content,
            height: "100%",
            onRowClick: _ctx.handleRowClick,
            class: "w-full"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_table_column, {
                prop: "category",
                label: "分类",
                width: "80"
              }, {
                default: _withId((scope) => [
                  _createTextVNode(_toDisplayString(scope.row.category.name), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "name",
                label: "名称"
              }),
              _createVNode(_component_el_table_column, {
                fixed: "right",
                label: "操作",
                width: "220"
              }, {
                default: _withId((scope) => [
                  _createVNode("div", _hoisted_8, [
                    _createVNode(_component_el_button, {
                      size: "small",
                      class: "margin-right-10",
                      onClick: ($event: any) => (_ctx.handleRowClick(scope.row)),
                      type: "success"
                    }, {
                      default: _withId(() => [
                        _hoisted_9
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_el_popconfirm, {
                      onConfirm: ($event: any) => (_ctx.deleteTemplate(scope.row)),
                      title: "确定删除吗？"
                    }, {
                      reference: _withId(() => [
                        _createVNode(_component_el_button, {
                          size: "small",
                          type: "danger"
                        }, {
                          default: _withId(() => [
                            _hoisted_10
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["onConfirm"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data", "onRowClick"]),
          _hoisted_11,
          _createVNode(_component_el_pagination, {
            class: "margin-top-10",
            total: _ctx.tableData.totalCount,
            "page-count": _ctx.tableData.totalPages,
            "current-page": _ctx.tableData.pageNumber,
            onCurrentChange: _ctx.reloadPage,
            onPrevClick: _ctx.reloadPage,
            onNextClick: _ctx.reloadPage,
            background: "",
            layout: "total, prev, pager, next, jumper"
          }, null, 8, ["total", "page-count", "current-page", "onCurrentChange", "onPrevClick", "onNextClick"])
        ])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      title: _ctx.editMode === 'ADD' ? '创建模板' : '编辑模板',
      modelValue: _ctx.templateDialogVisible,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.templateDialogVisible = $event)),
      width: "40%"
    }, {
      default: _withId(() => [
        _createVNode(_component_template_form, {
          template: _ctx.currentTemplate,
          onCancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.templateDialogVisible = false)),
          onSuccess: _ctx.templateUpdated
        }, null, 8, ["template", "onSuccess"])
      ]),
      _: 1
    }, 8, ["title", "modelValue"])
  ], 64))
})